import { Component, OnInit, OnChanges } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import {
  CartRow,
  CartRowPrice,
  Product,
  Availability,
  ProductService,
  PriceService,
  CartService,
  AvailabilityService,
  SelectedCustomerService,
  AuthService,
  Price
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { Subscription, forkJoin, of } from 'rxjs';
import { first, map } from 'rxjs';
import { JeevesSalesCartListComponent, JeevesSalesCartListRow } from 'gung-standard-jeeves';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'ref-ref-sales-cart-list',
    templateUrl: './ref-sales-cart-list.component.html',
    styleUrls: ['./ref-sales-cart-list.component.scss'],
    standalone: false
})
export class RefSalesCartListComponent extends JeevesSalesCartListComponent implements OnInit, OnChanges {
  isCapstone = environment.projectName === 'capstone';

  public updateDiscountPercentage(row: JeevesSalesCartListRow, value: any) {
    const oldVal = row.discountPercent;
    if (oldVal === value) {
      return;
    }

    if (!value && value !== 0) {
      this.cartService.removeExtraField(row.productId, 'orp.kundrabatt', row.targetStockId);
      return;
    }

    this.cartService.setExtra(row.productId, {
      orp: {
        kundrabatt: value
      }
    });
  }
}
